import { Box, Typography } from '@mui/material';
import { rapgemStoreGemsSrc } from '../../assets/bazzar';
import StoreCardShell, { rapGemHeaderGradient, StorePriceFooter } from './StoreCardShell';

function RapGemIcon() {
  return (
    <Box
      component="img"
      src={rapgemStoreGemsSrc}
      alt="RapGems"
      sx={{
        width: { xs: 54, md: 58 },
        height: { xs: 54, md: 58 },
        display: 'block',
        objectFit: 'contain',
        flexShrink: 0,
      }}
    />
  );
}

function RapGemStat({ title, subtitle }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 0, width: '100%', px: 0.25 }}>
      <RapGemIcon />
      <Typography
        sx={{
          color: '#fff',
          fontWeight: 700,
          fontSize: { xs: 32, md: 32 },
          lineHeight: '32px',
          letterSpacing: '0.8px',
          mt: { xs: 0.5, md: 0.75 },
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          color: '#fff',
          fontWeight: 400,
          fontSize: { xs: 10, md: 10 },
          lineHeight: '12px',
          textAlign: 'center',
          width: '100%',
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
}

export default function RapGemCard({ card, onClick }) {
  const isMix = card.gemType === 'mix';

  return (
    <StoreCardShell
      headerGradient={rapGemHeaderGradient}
      onClick={() => onClick(card)}
      footer={<StorePriceFooter price={card.price} originalPrice={card.originalPrice} />}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          gap: isMix ? { xs: 0.4, md: 1.8 } : 0,
          pt: { xs: 1.2, md: 2.2 },
          px: { xs: 0.25, md: 0 },
          height: { xs: '70%', md: '70%' },
        }}
      >
        {isMix ? (
          <>
            <RapGemStat title={card.title} subtitle={card.subtitle} />
            <RapGemStat title={card.secondaryTitle} subtitle={card.secondarySubtitle} />
          </>
        ) : (
          <RapGemStat title={card.title} subtitle='' />
        )}
      </Box>
    </StoreCardShell>
  );
}
